import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { RouteType } from '../../routes/routeType';
import { EXTERNAL_ROUTES } from '../../routes/routes';
import Layout from 'antd/lib/layout/layout';
import GlobalStyle from './styles';
import logisticacompleta from '../../assets/img/logisticacompleta.png';

const ExternalLayout: React.FC = () => {
  const renderRoutes = (prop: RouteType, index: number) => {
    return (
      <Route path={`${prop.layout}${prop.path}`} component={prop.component} key={index} exact />
    );
  };

  return (
    <Layout>
      <GlobalStyle />
      <div className="img">
        <img src={logisticacompleta} alt="Logística Completa" />

        <h1>OPERADOR LOGÍSTICO</h1>
        <h4>TRANSPORTE | ARMAZENAGEM | DISTRIBUIÇÃO</h4>
      </div>

      <Switch>
        {EXTERNAL_ROUTES.map(renderRoutes)}
        <Route exact path="/">
          <Redirect to="/login" />
        </Route>
      </Switch>
    </Layout>
  );
};

export default ExternalLayout;
